/* eslint-disable import/prefer-default-export */

export const AWIN_QUERY_KEY = 'awc';
export const AWIN_CLICK_REF_STORAGE_KEY = 'ckbk_awc';
export const AWIN_CLICK_REF_TTL_DAYS = 30;
export const AWIN_CHANNEL = 'aw';
export const AWIN_MASTERTAG_HOST = 'https://www.dwin1.com';
export const AWIN_PIXEL_HOST = 'https://www.awin1.com';
export const AWIN_S2S_PATH = '/sread.php';
export const AWIN_CONVERSION_API_ORDERS = '/s2s/advertiser/{id}/orders';
export const AWIN_DEFAULT_PART_CODE = 'DEFAULT';
export const AWIN_PART_CODE_BY_VOUCHER = {
  OCADOSMARTPASS: 'SMARTPASS',
};
